import React from 'react';
import SvgHome from '@components/icons/Home.tsx';
import SvgChevronRight from '@components/icons/ChevronRight.tsx';
import { IconWrapper } from '@components/icons/IconWrapper.tsx';
import { Link } from '@tanstack/react-router';

export type BreadcrumbItem = { label: string; href: string | undefined } | { label: string; onClick: () => void };

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  prefixItems?: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbProps> = ({ items, prefixItems = [] }) => {
  const allItems = [...prefixItems, ...items];
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap gap-2 items-center">
        <li className="flex items-center">
          <IconWrapper className={'h-4 w-4'}>
            <SvgHome />
          </IconWrapper>
          <IconWrapper className={'h-4 w-4'}>
            <SvgChevronRight />
          </IconWrapper>
        </li>
        {allItems.map((item, i) => (
          <li key={i} className="flex items-center text-body-xs">
            {'href' in item ? (
              <>
                {item.href ? (
                  <Link to={item.href} className="text-control-link-dark-main">
                    {item.label}
                  </Link>
                ) : (
                  <span className={'text-lighter'}>{item.label}</span>
                )}
              </>
            ) : (
              <button onClick={item.onClick} className="text-control-link-dark-main" title={item.label}>
                {item.label}
              </button>
            )}
            {i < allItems.length - 1 && (
              <IconWrapper className={'h-4 w-4'}>
                <SvgChevronRight />
              </IconWrapper>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
